import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { getProperties } from "../apis/channelManager";

const isRestrictedRole = (role) => role === "resort-supervisor" || role === "resort-manager";

const currentUserRole = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null")?.role?.role_name || null;
  } catch (error) {
    return null;
  }
};

/**
 * Prevents a property user from rendering a property route they do not own.
 * The API remains authoritative; this guard avoids flashing another tenant's
 * page when a user manually changes the URL.
 */
export const TenantPropertyRouteGuard = ({ children }) => {
  const { id } = useParams();
  const [state, setState] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let active = true;
    if (!isRestrictedRole(currentUserRole())) {
      setState({ loading: false, allowed: true });
      return () => { active = false; };
    }

    getProperties()
      .then((payload) => {
        const properties = payload?.resorts || payload || [];
        const allowed = Array.isArray(properties) && properties.some((property) => String(property.resort_id) === String(id));
        if (active) setState({ loading: false, allowed });
      })
      .catch(() => active && setState({ loading: false, allowed: false }));

    return () => { active = false; };
  }, [id]);

  if (state.loading) return <div className="rounded-2xl border border-slate-200 bg-white p-8 text-slate-600 shadow-sm">Checking property access…</div>;
  return state.allowed ? children : <Navigate to="/dashboard/property" replace />;
};

export const PropertyUserDashboardGuard = ({ children }) => {
  const role = currentUserRole();
  return isRestrictedRole(role) ? <Navigate to="/dashboard/property" replace /> : children;
};

/**
 * Calendar generation and deletion are global operations. Keep the route
 * hidden from non-global administrators while the API remains authoritative.
 */
export const GlobalAdminRouteGuard = ({ children }) => (
  currentUserRole() === "super-admin" ? children : <Navigate to="/dashboard" replace />
);
